import { html } from 'lit';
import { highlightedHeading } from './highlightedHeading.js';
import { editorSemanticText } from '../editor/editorSemanticText.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

interface SectionHeadingOptions {
  eyebrow: string;
  title: string;
  headingTag?: 'h1' | 'h2';
  highlight?: string;
  text?: string;
  align?: 'left' | 'center';
  editor?: LandingEditorRenderOptions;
  elementPrefix?: string;
}

const elementId = (prefix: string | undefined, suffix: string) => (prefix ? `${prefix}.${suffix}` : undefined);

export const sectionHeading = ({
  eyebrow,
  title,
  headingTag = 'h1',
  highlight,
  text,
  align = 'left',
  editor,
  elementPrefix,
}: SectionHeadingOptions) => {
  const headingId = elementId(elementPrefix, 'heading');
  const eyebrowId = elementId(elementPrefix, 'eyebrow');
  const headingClass = `vp-section-heading ${align === 'center' ? 'vp-section-heading-center' : ''}`;

  return html`
    <div
      class=${headingId ? editorNodeClass(editor, headingId, headingClass) : headingClass}
      style=${headingId ? editorNodeStyle(editor, headingId) : ''}
      @pointerdown=${(event: PointerEvent) => headingId && editorNodePointerDown(editor, headingId, event)}
      @click=${(event: MouseEvent) => headingId && editorNodeClick(editor, headingId, event)}
    >
      ${eyebrow
        ? html`
            <p
              class=${eyebrowId ? editorNodeClass(editor, eyebrowId, 'vp-eyebrow') : 'vp-eyebrow'}
              style=${eyebrowId ? editorNodeStyle(editor, eyebrowId) : ''}
              @pointerdown=${(event: PointerEvent) => eyebrowId && editorNodePointerDown(editor, eyebrowId, event)}
              @click=${(event: MouseEvent) => eyebrowId && editorNodeClick(editor, eyebrowId, event)}
            >
              ${eyebrow}
            </p>
          `
        : ''}
      ${highlightedHeading({
        title,
        headingTag,
        highlight,
        editor,
        titleElementId: elementId(elementPrefix, 'title'),
        highlightElementId: elementId(elementPrefix, 'titleHighlight'),
      })}
      ${text
        ? (() => {
            const id = elementId(elementPrefix, 'text');
            return editorSemanticText({
              editor,
              elementId: id,
              fallbackTag: 'p',
              className: 'vp-section-text',
              content: text,
            });
          })()
        : ''}
    </div>
  `;
};
